import {FC, useState} from "react";
// import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {urlApi} from "../../../helper/api";
// import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {ITypeRadar} from "../../../types";
import {
  IClusterDataFromServer,
  // IClusterDataSideBar,
  IMetricsData,
} from "../../../pages/Dashboard/Dashboard.type";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {dataMapClusterFilters} from "../dataMapFilters";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleCard} from "../styles";
import {MarketScienceCharts} from "../SidebarCardUI/MarketScienceCharts/MarketScienceCharts";
import {MarketScienceChartPanel} from "../SidebarCardUI/MarketScienceCharts/MarketScienceChartPanel";
import {SideBarContentMapBattery} from "./SideBarContentMapBattery";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../../config/featureFlags";

interface IProps {
  dataCluster: IClusterDataFromServer | undefined;
  typeRadar: ITypeRadar;
  handleSecondStepCpu: (id: string) => void;
  handleSortTitle: any;
  handleSort: any;
  sortOption: string;
  colorTitle?: string;

  titleCluster: string;
  setIsShowCharts: (value: boolean) => void;
  isShowCharts: boolean;
}

export const SideBarContentMapClusters: FC<IProps> = ({
  dataCluster,
  typeRadar,
  handleSecondStepCpu,
  handleSortTitle,
  handleSort,
  sortOption,
  colorTitle,
  titleCluster,
  setIsShowCharts,
  isShowCharts,
}) => {
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);

  return (
    <>
      <TitleCard color={colorTitle}>{titleCluster}</TitleCard>
      {!isShowCharts ? (
        <>
          {/* <BlockToggleDescriptionTehnology
        data={
          <BlockDescription
            text={dataCluster?.desc}
            image={`${urlApi}/cms/techradar${dataCluster?.image?.url}`}
          />
        }
        title={<TitleBlockTrend title="ОПИСАНИЕ ТЕХНОЛОГИЧЕСКОГО КЛАСТЕРА" />}
        isOpen
        typeRadar={typeRadar}
      /> */}
          <BlockDescription
            text={dataCluster?.desc}
            image={
              dataCluster?.image?.url &&
              `${urlApi}/cms/techradar${dataCluster?.image?.url}`
            }
          />

          {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED && (
            <SideBarContentMapBattery
              batteryRussia={dataCluster?.battery_russia ?? ""}
              batteryWorld={dataCluster?.battery_world ?? ""}
              type="cluster"
            />
          )}

          <MarketScienceCharts openCharts={() => setIsShowCharts(true)} />
          <BlockFIlteredMap
            handleSortTitle={handleSortTitle}
            handleSort={handleSort}
            sortOption={sortOption}
            dataMapFiltered={dataMapClusterFilters}
            setIsShowTitleParams={setIsShowTitleParams}
            isShowTitleParams={isShowTitleParams}
          />
          {dataCluster?.technologies.map((item) => {
            return (
              <CardItem
                key={item.id}
                invest_volume_tier={item.invest_volume_tier}
                potential_volume_tier={item.potential_volume_tier}
                trl_tier={item.trl_tier}
                title={item.name}
                maturity={item.maturity}
                isFlashFilterEnabled={item.growth_potential}
                isCritical={
                  ("critical" in item ? item.critical : null) as
                    | boolean
                    | undefined
                }
                isGpb={item.gpb}
                type={SidebarTab.Clusters}
                isNational={
                  ("national" in item ? item.national : null) as
                    | boolean
                    | undefined
                }
                onClick={() => handleSecondStepCpu(item.documentId || "")}
                imageCard={
                  "image" in item ? (item.image as string | undefined) : ""
                }
                isShowTitleParams={isShowTitleParams}
                typeRadar={typeRadar}
                batteryRussia={item.battery_russia || ""}
                batteryWorld={item.battery_world || ""}
              />
            );
          })}
        </>
      ) : (
        <MarketScienceChartPanel
          dataCharts={dataCluster?.metrics_data || ({} as IMetricsData)}
        />
      )}
    </>
  );
};
